import { render, staticRenderFns } from "./SmsMessageHistory.vue?vue&type=template&id=cb238200&scoped=true"
import script from "./SmsMessageHistory.vue?vue&type=script&lang=js"
export * from "./SmsMessageHistory.vue?vue&type=script&lang=js"
import style0 from "./SmsMessageHistory.vue?vue&type=style&index=0&id=cb238200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb238200",
  null
  
)

export default component.exports